import { InjectionToken } from '@angular/core';
import { AssetRepositoryPort } from './asset-repository.port';

/**
 * Injection token for AssetRepositoryPort
 * Used for dependency injection since interfaces don't exist at runtime
 */
export const ASSET_REPOSITORY = new InjectionToken<AssetRepositoryPort>(
  'AssetRepository',
  {
    providedIn: 'root',
    factory: () => {
      throw new Error(
        'ASSET_REPOSITORY must be provided. Use MockAssetRepositoryAdapter or AssetInstancesApiAdapter.',
      );
    },
  },
);
